import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS } from "@/lib/constants";

export default function Footer({ onOpenConsult }) {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1628] border-t border-white/10 pt-24 md:pt-32 pb-10 px-6 md:px-12 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand mark */}
          <div className="lg:col-span-6">
            <div className="overline mb-6">Edmonton · Alberta · Canada</div>
            <img
              src="/brand/unexx-logo.png"
              alt="U-NEXX Development Group Inc."
              className="w-auto h-40 sm:h-48 md:h-56 max-w-full object-contain -ml-2"
            />
            <p className="mt-8 max-w-md text-[#8FA3B8] leading-relaxed text-sm">
              A full-service real estate development and consulting firm. We transform opportunity into ownership for investors at home and abroad.
            </p>
            <button
              type="button"
              data-testid="footer-book-consult"
              onClick={onOpenConsult}
              className="btn-link mt-8"
            >
              Begin a Project <span>→</span>
            </button>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-6">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.testId}>
                  {l.external ? (
                    <a data-testid={`footer-${l.testId}`} href={l.href} className="text-[#F3EFE4] hover:text-[#D4AF37] transition text-sm">
                      {l.label}
                    </a>
                  ) : (
                    <Link data-testid={`footer-${l.testId}`} to={l.to} className="text-[#F3EFE4] hover:text-[#D4AF37] transition text-sm">
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-6">Services</div>
            <ul className="space-y-3 text-sm text-[#F3EFE4]">
              <li>Land Development</li>
              <li>Property Flipping</li>
              <li>International Investors</li>
              <li>Project Management</li>
              <li>Investment Consulting</li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-6">Contact</div>
            <ul className="space-y-3 text-sm text-[#F3EFE4]">
              <li>
                <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="hover:text-[#D4AF37] transition">
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a href={`tel:${BRAND.phone.replace(/\D/g, "")}`} data-testid="footer-phone" className="hover:text-[#D4AF37] transition">
                  {BRAND.phone}
                </a>
              </li>
              <li className="text-[#8FA3B8]">{BRAND.address}</li>
              <li className="text-[#8FA3B8]">{BRAND.founded}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#8FA3B8]">
          <div>© {new Date().getFullYear()} U-NEXX Development Group Inc. All rights reserved.</div>
          <div className="tracking-[0.3em] uppercase">Building · Developing · Delivering</div>
        </div>
      </div>
    </footer>
  );
}
